import { IkeDelayedTask } from '@ikegps/core-shared';
import { type IObservableValue, observable, transaction } from 'mobx';

interface ObjectSet {
	observableValue: IObservableValue<any>;
	value: any;
}

const batch: ObjectSet[] = [];

function processBatch() {
	for (const item of batch) {
		item.observableValue.set(item.value);
	}
}

function resolveBatch() {
	transaction(processBatch);
	batch.length = 0;
}

const resolveBatchTask = new IkeDelayedTask(resolveBatch, 100);

function ensureObservable(target: any, observableName: string): IObservableValue<any> {
	if (target[observableName] != null) {
		return target[observableName];
	}

	const observableValue = observable.box(null, { name: observableName, deep: false });
	target[observableName] = observableValue;
	return observableValue;
}

/** mobx.observable which sets immediatly but notifies after a short delay */
export function batchObservable(target: any, propertyName: string) {
	const observableName = '_' + propertyName;
	const internalValueName = '__' + propertyName;

	Object.defineProperty(target, propertyName, {
		enumerable: true,
		get: function () {
			const observableValue = ensureObservable(this, observableName);
			observableValue.get();
			return this[internalValueName];
		},
		set: function (value) {
			const observableValue = ensureObservable(this, observableName);

			// Set value immediatly for sync get
			this[internalValueName] = value;

			// Delay mobx set to batch reactions
			batch.push({ observableValue, value });
			resolveBatchTask.delay();
		},
	});
}
